import classNames from 'clsx';
import React from 'react';
import { matchPath, useLocation } from 'react-router';

import Link from '@swf/components/Link/Link';
import type { ClassNameProp } from '@swf/core/types/Props';
import type { MainNavigationBlock } from '@swf/generated/cms/types/SiteHeader';

import useCustomHeader from '../../../../hooks/useCustomHeader';

import styles from './BrandLinks.scss';
import type { Props as IconProps } from './Icon/Icon';
import Icon from './Icon/Icon';

export enum Vertical {
  Poker = 'poker',
  Casino = 'casino',
  Sports = 'sports'
}

interface OwnProps {
  brandsInMenu?: boolean;
  main: MainNavigationBlock[];
}

export type Props = Partial<ClassNameProp> & OwnProps;

const BrandLinks: React.FC<Props> = ({ brandsInMenu = false, className, main }) => {
  const { pathname } = useLocation();
  const { prospectHeader } = useCustomHeader();
  let children;

  if (main?.length) {
    const activeItem = [...main]
      .sort((a, b) => (b.url && a.url ? b.url.length - a.url.length : 0))
      .find((item) => !!matchPath(pathname, { path: item.url }));

    children = main.map((item) => {
      const active = item.url === activeItem?.url && !prospectHeader;

      return (
        <Link
          key={item.url}
          href={item.url}
          trackText={item.track_id}
          title={item.title as string}
          className={classNames(styles.brandLink, {
            [styles.mobileBrandsIcon]: brandsInMenu,
            [styles.active]: active
          })}
        >
          <Icon icon={item.icon as IconProps['icon']} active={active} />
        </Link>
      );
    });
  }

  return <div className={classNames(styles.brandLinks, className)}>{children}</div>;
};

export default BrandLinks;
